/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DisplayDeviceType {
    PlayerScreen = 0,
    FloorScreen = 1,
    RoomStateScreen = 2,
}
